
import { AlertTriangle, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

interface ErrorCardProps {
  onRetry: () => void;
}

export const ErrorCard = ({ onRetry }: ErrorCardProps) => (
  <Card className="border-red-200 bg-red-50">
    <CardHeader>
      <CardTitle className="flex items-center gap-2 text-red-700">
        <AlertTriangle className="w-5 h-5" />
        خطأ في تحميل البيانات
      </CardTitle>
      <CardDescription className="text-red-600">
        حدث خطأ أثناء تحميل البيانات. يرجى المحاولة مرة أخرى.
      </CardDescription>
    </CardHeader>
    <CardContent>
      <Button 
        onClick={onRetry} 
        variant="outline" 
        className="border-red-300 text-red-700 hover:bg-red-100"
      >
        <RefreshCw className="w-4 h-4 mr-2" />
        إعادة المحاولة
      </Button>
    </CardContent>
  </Card>
);
